import React, { Fragment } from "react";
import { connect } from "react-redux";

import SourceField from "./MapperBlock/SourceField";

import { dragDataPlayfieldAction } from "../../../actions/FieldsSetting/fieldsSettingActions";

import { SOURCE_FIELD } from "../../../constants/fields";

const FieldsPool = ({
  searchInput,
  filterState,
  currentObject,
  currentDataSource,
  sourceObjSchema,
  dragDataPlayfield,
  showMenuType,
  csvData,
  dataSourceSelected,
  showCSVFields,
  searchRelatedObjects,
}) => {
  const _handleSourceFieldDrag = sourceFieldName => {
    dragDataPlayfield(SOURCE_FIELD, sourceFieldName);
  };
  let fieldsList = [];
  if (
    currentDataSource === "csv" &&
    csvData &&
    Array.isArray(csvData.fields) &&
    showCSVFields
  ) {
    fieldsList = csvData.fields;
    const uniqueHeaders = [];
    fieldsList = fieldsList.filter(field => {
      const isDuplicate = uniqueHeaders.includes(field.label.toLowerCase());
      if (!isDuplicate) {
        uniqueHeaders.push(field.label.toLowerCase());
        return true;
      }
      return false;
    });
    if (searchInput && searchInput !== "") {
      fieldsList = fieldsList.filter(field =>
        field.label.toLowerCase().includes(searchInput.toLowerCase()),
      );
    }
  } else {
    const sourceObject =
      currentObject && currentObject.name in sourceObjSchema
        ? sourceObjSchema[currentObject.name]
        : [];
    if (filterState && Array.isArray(sourceObject[filterState])) {
      fieldsList = sourceObject[filterState];
    }
    if (searchInput && searchInput !== "") {
      fieldsList = fieldsList.filter(field =>
        field.label.toLowerCase().includes(searchInput.toLowerCase()),
      );
    }

    if (showMenuType === "TABLE") {
      fieldsList = fieldsList.filter(
        field =>
          field.parent_field_type &&
          field.parent_field_type === "multi_reference",
      );
    }
  }
  let poolHeader = `List of all ${currentDataSource.urlRef} fields in [${currentObject.label}] object`;
  if (dataSourceSelected === "csv" && Object.keys(csvData).length === 0) {
    poolHeader = "";
  } else if (dataSourceSelected === "csv" && Object.keys(csvData).length > 0) {
    poolHeader = "Unassigned fields";
  }
  return (
    <div className="unassigned-sf-fields-container">
      <div className="unassigned-sf-fields-head">
        <div className="assigned-sf-field-head">{poolHeader}</div>
      </div>
      <div className="unassigned-sf-body">
        <div className="unassigned-sf-fields content-scrollable">
          {dataSourceSelected === "csv" && !showCSVFields ? (
            <Fragment />
          ) : (
            searchRelatedObjects()
          )}
          <div className="unassigned-sf-fields-list">
            {fieldsList.map(field => (
              <SourceField
                draggable
                handleDragStart={() => _handleSourceFieldDrag(field.name)}
                key={field.name}
                title={field.label}
                isRemoveAllowed={false}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  FieldsSettingStore: { sourceObjSchema, csvData, dataSourceSelected },
}) => ({
  sourceObjSchema,
  csvData,
  dataSourceSelected,
});

const mapDispatchToProps = {
  dragDataPlayfield: dragDataPlayfieldAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(FieldsPool);
